import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ClientMagicLinkVerify = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const [status, setStatus] = useState('verifying');
  const [error, setError] = useState('');

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setError('No token provided.');
      return;
    }

    axios.post(`${API_URL}/auth/magic-link/verify`, { token })
      .then((res) => {
        const { token: jwt, user } = res.data;
        loginWithToken(jwt, user);
        setStatus('success');
        setTimeout(() => navigate('/client/dashboard'), 1000);
      })
      .catch((err) => {
        setStatus('error');
        setError(err.response?.data?.message || 'This link is invalid or has expired.');
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f7f0] to-[#e8edda] dark:from-[#131a0b] dark:to-[#1e2711] flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <div className="flex justify-center mb-6">
          <img src="/bda-logo.png" alt="BDA Technologies" className="h-12 w-auto" />
        </div>
        <div className="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xl p-10">
          {status === 'verifying' && (
            <>
              <Loader2 className="w-12 h-12 animate-spin text-[#556B2F] mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-slate-900 dark:text-white">Signing you in…</h2>
              <p className="text-slate-500 mt-2 text-sm">Verifying your magic link</p>
            </>
          )}
          {status === 'success' && (
            <>
              <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-slate-900 dark:text-white">Signed in!</h2>
              <p className="text-slate-500 mt-2 text-sm">Redirecting to dashboard…</p>
            </>
          )}
          {status === 'error' && (
            <>
              <XCircle className="w-12 h-12 text-red-500 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-slate-900 dark:text-white">Link invalid</h2>
              <p className="text-slate-500 mt-2 text-sm mb-6">{error}</p>
              <Button onClick={() => navigate('/client/login')} className="bg-[#556B2F] hover:bg-[#3d4f22] text-white">
                Back to Login
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientMagicLinkVerify;
